import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHealthy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={38}
    fill="none"
    aria-label="Healthy"
    {...props}
  >
    <path
      fill="#08967E"
      d="M18.9 3.78c8.35 0 15.12 6.77 15.12 15.12S27.25 34.02 18.9 34.02 3.78 27.25 3.78 18.9 10.55 3.78 18.9 3.78"
    />
    <path
      fill="#FFF"
      d="M27.085 12.715a1.467 1.467 0 0 0-2.075 0l-9.378 9.378-3.308-3.25a1.467 1.467 0 0 0-2.057 2.093l3.937 3.868c.801.787 2.086.78 2.88-.013L27.085 14.79a1.467 1.467 0 0 0 0-2.075"
    />
  </svg>
);
export default SvgHealthy;
